import React from "react";
import IFormElementProps from "../../../../../../model/interface/form/IFormElementProps";
import IField, {
    buildCompositeFieldName,
    COMPOSITE_FIELD_FIELDS,
    IFieldOptions
} from "../../../../../../model/interface/dataStorage/IField";
import {
    ICompositeFieldCoordinatesOptions
} from "../../../content-type/field/optionEditors/composite/CompositeFieldCoordinatesOptionsEditor";
import {Input, Row, Typography} from "antd";
import ICompositeFieldData from "../../../../../../model/interface/dataStorage/field/composite/ICompositeFieldData";
import {connect, RootStateOrAny} from "react-redux";
import IUser from "../../../../../../model/interface/security/IUser";
import {AimOutlined, ColumnHeightOutlined, ColumnWidthOutlined} from "@ant-design/icons";
import Button from "../../../../../shared/button/Button";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import Map from "../../../../../shared/map/Map";


interface IProps extends IFormElementProps {
    value?: ICompositeFieldData,
    onChange?: (value: ICompositeFieldData) => void
    options: ICompositeFieldCoordinatesOptions & IFieldOptions
    field: IField,
    user: IUser,
}

interface IState {
    findingLocation?: boolean
    locationPermissionFailed?: boolean
    currentLocation?: boolean
}


class FormCompositeFieldCoordinates extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    onChange = (property: string, change: any) => {
        const {onChange, value} = this.props
        onChange?.({...value, [property]: change})
    }


    getCurrentLocation = () => {
        const {onChange} = this.props

        this.setState({findingLocation: true})
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                // 1. Success Callback
                (position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
                    onChange?.({[this.LONGITUDE]: longitude, [this.LATITUDE]: latitude})
                    this.setState({findingLocation: false, currentLocation: true})
                    // You can now use these coordinates in your app
                },
                // 2. Error Callback
                (error) => {
                    console.error("Error getting location:", error.message);
                    this.setState({findingLocation: false, locationPermissionFailed: true})
                    // Handle different error types (permission denied, timeout, etc.)
                },
                // 3. Options (Optional)
                {
                    enableHighAccuracy: true, // Request the best possible results
                    timeout: 5000,            // Maximum time (in ms) to wait for a result
                    maximumAge: 0             // Don't use a cached position
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    }

    render() {
        const {options, value, onChange} = this.props
        const {findingLocation, locationPermissionFailed, currentLocation} = this.state

        const {current, pick, showMap, manual, disabled, mapWidth, mapHeight} = options


        return (
            <div>
                <Row justify={'space-between'} className={'mb-2'} wrap={false}>
                    {current && (
                        <div>
                            <Button className={'mr-2'} type={"info"} icon={<AimOutlined/>} disabled={locationPermissionFailed} onClick={this.getCurrentLocation} loading={findingLocation}>
                                <LocaleText code={'configuration.form.field.composite-coordinates.current-location'}
                                            fallback={'Aktuální poloha'}/>
                            </Button>
                            {locationPermissionFailed && (
                                <Typography.Text className={'d-block'} type={'danger'}>[<LocaleText code={'configuration.form.field.composite-coordinates.current-location-permission'} fallback={'Přístup k poloze byl zamítnut, prosím povolte ve vašem prohlížeči'}/>]</Typography.Text>
                            )}
                            {currentLocation && value && (
                                <Typography.Text className={'d-block'} type={'success'}>[{value?.[this.LATITUDE]}, {value?.[this.LONGITUDE]}]</Typography.Text>
                            )}
                        </div>
                    )}
                    {manual && (
                        <>
                            <Input.Group className={'w-auto'} compact>
                                <Input style={{width: '50%'}} disabled={disabled} value={value?.[this.LATITUDE]}
                                       suffix={<ColumnWidthOutlined/>}
                                       onChange={e => this.onChange(this.LATITUDE, e.target.value)}/>
                                <Input style={{width: '50%'}} value={value?.[this.LONGITUDE]} disabled={disabled}
                                       suffix={<ColumnHeightOutlined/>}
                                       onChange={e => this.onChange(this.LONGITUDE, e.target.value)}/>
                            </Input.Group>
                        </>
                    )}
                </Row>

                {(showMap || pick) && (
                    <Map
                        points={value?.[this.LONGITUDE] && value?.[this.LATITUDE] ? [{lat: value?.[this.LATITUDE], long: value?.[this.LONGITUDE]}] : []} width={mapWidth} height={mapHeight}
                        onClick={(coords) => onChange?.({[this.LONGITUDE]: coords.long, [this.LATITUDE]: coords.lat})}
                    />
                )}
            </div>
        )
    }

    LATITUDE = buildCompositeFieldName(this.props.field.name, COMPOSITE_FIELD_FIELDS.COORDINATES.LATITUDE)
    LONGITUDE =  buildCompositeFieldName(this.props.field.name, COMPOSITE_FIELD_FIELDS.COORDINATES.LONGITUDE)
}

const mapStateToProps = (state: RootStateOrAny) => {
    const {user} = state.setup
    return {
        user
    }
}
export default connect(mapStateToProps)(FormCompositeFieldCoordinates)